import { render, staticRenderFns } from "./UsView.vue?vue&type=template&id=5dce1891&scoped=true"
import script from "./UsView.vue?vue&type=script&lang=js"
export * from "./UsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce1891",
  null
  
)

export default component.exports